<template>
    <div class="main-content">
        <div class="container-fluid p-0" :class="{ 'container-fluid-height' : $route.params.doc_id }">
            <div class="dax-search-content">
                <div class="row">
                    <div class="col-12">
                        <div class="board-main-content">
                            <div class="board-wrapper">
                                <div class="board-heading">
                                    <div class="heading">
                                        <textarea-autosize v-model="board.name"
                                                           class="form-control col-12 board-input-title"
                                                           @blur.native="updateBoardProperty($event, 'name')"
                                                           rows="1"
                                        ></textarea-autosize>
                                        <textarea-autosize v-model="board.description"
                                                           class="board-input-description"
                                                           @blur.native="updateBoardProperty($event, 'description')"
                                                           rows="1"
                                        ></textarea-autosize>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-12 col-lg-8">
                                        <div class="dev-priorities-box mb-4">
                                            <div class="board-list-header" v-if="!renameTitle" @click="enableEditName()">
                                                <div class="board-cart-name text-word-break" placeholder="Column Title" >{{ board.section1.name }}</div>
                                            </div>
                                            <div class="board-list-header" v-else>
                                                <div class="board-cart-name">
                                                    <input v-model="board.section1.name"
                                                           @blur="renameColumn($event, 'section1')" />
                                                </div>
                                            </div>
                                            <BackLog
                                                :tasks="board.section1.tasks"
                                                :section="1"
                                                :cols="3"
                                                :minh="350"
                                                :board="board"
                                                :location="'section1'"
                                                :location_set="3"
                                            />
                                        </div>

                                        <div class="dev-priorities-box">
                                            <div class="board-list-header" v-if="!renameTitle" @click="enableEditName()">
                                                <div class="board-cart-name text-word-break" placeholder="Column Title" >{{ board.section3.name }}</div>
                                            </div>
                                            <div class="board-list-header" v-else>
                                                <div class="board-cart-name">
                                                    <input v-model="board.section3.name"
                                                           @blur="renameColumn($event, 'section3')" />
                                                </div>
                                            </div>
                                            <BackLog
                                                :tasks="board.section3.tasks"
                                                :section="3"
                                                :cols="3"
                                                :minh="230"
                                                :board="board"
                                                :location="'section3'"
                                                :location_set="3"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-12 col-lg-4">
                                        <div class="dev-priorities-box  mb-4 mmt-30">
                                            <div class="board-list-header" v-if="!renameTitle" @click="enableEditName()">
                                                <div class="board-cart-name text-word-break" placeholder="Column Title" >{{ board.section2.name }}</div>
                                            </div>
                                            <div class="board-list-header" v-else>
                                                <div class="board-cart-name">
                                                    <input v-model="board.section2.name"
                                                           @blur="renameColumn($event, 'section2')" />
                                                </div>
                                            </div>
                                            <BackLog
                                                :tasks="board.section2.tasks"
                                                :section="2"
                                                :cols="2"
                                                :minh="420"
                                                :board="board"
                                                :location="'section2'"
                                                :location_set="2"
                                            />
                                        </div>

                                        <div class="dev-priorities-box">
                                            <div class="board-list-header" v-if="!renameTitle" @click="enableEditName()">
                                                <div class="board-cart-name text-word-break" placeholder="Column Title" >{{ board.section4.name }}</div>
                                            </div>
                                            <div class="board-list-header" v-else>
                                                <div class="board-cart-name">
                                                    <input v-model="board.section4.name"
                                                           @blur="renameColumn($event, 'section4')" />
                                                </div>
                                            </div>
                                            <BackLog
                                                :tasks="board.section4.tasks"
                                                :section="4"
                                                :cols="2"
                                                :minh="165"
                                                :board="board"
                                                :location="'section4'"
                                                :location_set="4"
                                            />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DocumentContent />
        <router-view />
        <v-dialog :clickToClose="false" :width="500"
                  :adaptive="true" :max-width="'80%'" />
        <doc-clone-name v-if="settingCloneTitle" :tinyMceOff="'on'"></doc-clone-name>
    </div>
</template>

<script>
import BackLog from "./BackLog";
import store from "./../../store/modules/model-planner"
import {mapGetters, mapState} from "vuex";
import MovingDataPlannerItems from "../../mixins/MovingDataPlannerItems";
import DocumentHttpService from "../../services/DocumentHttpService";
import DocumentContent from "./../DocumentContent";
import ApiService from "../../api/api.service";
import vmodal from 'vue-js-modal'
import DocCloneName from "./../DocCloneName";

export default {
    name: "ModelPlanner",
    components: { BackLog,ApiService, vmodal, DocCloneName, DocumentContent },
    data: () => {
        return {
            docService: new DocumentHttpService(),
            titleEdit: false,
            descriptionEdit: false,

            enableExtraClick: true,


            lockedForEditing: false,
            settingCloneTitle: false,
            renameTitle: false,
        }
    },
    beforeCreate() {
        this.$store = store; // No way around this
    },
    computed: {
        ...mapState(['board']),
    },
    mixins: ['MovingDataPlannerItems'],
    mounted() {
        const titleEl = document.querySelector('head title');
        titleEl.textContent = 'Data Model Planner - Analyst Hub by Enterprise DNA';

        // Cloning
        if(this.$route.query.clone) {
            this.settingCloneTitle = true;
        }
        if(this.$route.params.doc_id) {
            this.loadData(this.$route.params.doc_id);

        } else {
            // new doc
            this.checkPaidPlanAccess();

            this.board.name = 'Title this Data Model Planner...';
            this.board.description = 'Add a compelling description of the data model';
            this.board.columns = []
        }
    },

    methods: {
        loadData(id) {
            this.docService.get(id)
                .then(({data}) => {
                    if(data.doc) {
                        this.checkPaidPlanAccess(data.doc.latest_three);

                        const titleEl = document.querySelector('head title');
                        titleEl.textContent = data.doc.name + ' - Analyst Hub by Enterprise DNA';

                        this.$store.commit('LOAD_DATA', {
                            data: {
                                document_db_id: data.doc.id,
                                document_url_id: data.doc.document_id,
                                entity_id: data.entity.id,
                                name: data.doc.name,
                                description: data.doc.description,
                                entity_name: 'Model Planner',
                                entity_group: 'Model Planner',
                                section1: data.entity.section1 || [],
                                section2: data.entity.section2 || [],
                                section3: data.entity.section3 || [],
                                section4: data.entity.section4 || [],
                                user: data.doc.user,
                                team_id: data.doc.team_id || null,
                                team_shared: data.doc.team_shared || false,
                                created_at: data.doc.created_at,
                            }
                        });

                        if(data.doc.team_shared) {
                            this.getLockedStatus();
                        }


                    } else {
                        this.$router.push({'name': 'Analytics Planner'});
                    }



                })
                .catch((response) => {
                    console.log(response);
                });
        },
        checkPaidPlanAccess(latestThree) {
            // restriction check
            this.userData = JSON.parse(localStorage.getItem('user'));
            if(typeof latestThree == 'undefined') {
                if(this.userData.free_plan && this.userData.documents_count >= 3) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            } else {
                if(this.userData.free_plan && !latestThree) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            }
        },

        saveDoc(data, entity_data) {
            let formData = data;
            formData.document_id = this.board.document_url_id;

            ApiService.setHeader();
            ApiService.post('/api/document/clone', formData)
                .then(({data}) => {
                    this.$router.push({'name': 'Data Model Planner', params: {doc_id: data.doc.document_id}} )
                    this.loadData(data.doc.document_id);
                    setTimeout(() => {
                        this.settingCloneTitle = false;
                    }, 2000);
                })
                .catch((response) => { console.log(response) })
        },

        updateBoardProperty(e, key) {
            this.$store.commit('UPDATE_BOARD', {
                key,
                value: e.target.value
            })
        },

        enableColumnTx() {
            this.enableExtraClick = false;
            setTimeout(() => {
                this.$refs.columnTextArea.focus()
            })
        },

        // get document locked status
        getLockedStatus() {

            if(this.board.team_shared) {
                ApiService.setHeader();
                ApiService.get('/api/locked-status/' + this.$route.params.doc_id)
                    .then(({data}) => {
                        this.lockedForEditing = data.locked;
                        if(data.locked) {
                            this.$modal.show('dialog', {
                                title: '&nbsp;',
                                text: '<p class="text-center"><strong>' + data.user.name + '</strong> may still be editing this document.</p>' +
                                    '<p class="text-center">Currently, only one team member can edit a document simultaneously. You can force takeover to start editing, or go back if you believe ' + data.user.name + ' is currently editing on the document.</p>',
                                buttons: [
                                    {
                                        title: 'Go back',
                                        handler: () => {
                                            this.$router.back();
                                        }
                                    },
                                    {
                                        title: '<span class="text-danger">Take over</span>',
                                        handler: () => {

                                            ApiService.setHeader();
                                            ApiService.get('/api/takeover-locked-status/' + this.$route.params.doc_id)
                                                .then(({data}) => {
                                                    this.$modal.hide('dialog');
                                                })
                                                .catch((response) => { console.log(response) });
                                        }
                                    }
                                ]
                            })

                        }
                    })
                    .catch((response) => {
                        console.log(response)
                    });
            }
        },

        enableEditName() {
            this.renameTitle = true;
        },

        renameColumn(e, sec) {
            this.$store.commit('UPDATE_COLUMN_NAME', {
                columnIndex: this.columnIndex,
                value: e.target.value,
                sec: sec
            })
            this.renameTitle = false;
        }
    }
}


</script>

<style scoped>
@media screen and (max-width: 991px) {
    .mmt-30 {
        margin-top: 30px;
    }
}

@media screen and (min-width: 992px) {
    .mt-30 {
        margin-top: 30px;
    }

    .mt--40 {
        margin-top: -40px;
    }

}

.dev-priorities-box {
    height: auto;
}
.board-list-header {
    padding: 0;
}


.board-list-header input {
    border: 0;
    font-size: 25px;
    font-weight: 700;
    font-family: "Fira Sans", sans-serif;
    background: transparent;
    border-radius: 0;
    max-height: 256px;
    min-height: 30px;
    padding: 0;
    display: block;
    width: 100%;
    caret-color: #1E73BD;
}

    :root {
        touch-action: pan-x pan-y;
        height: 100%
    }
    .container-fluid-height {
        min-height: 80vh;
        height: 80vh;
        overflow-y: scroll;
        overflow-x:hidden;
    }
    @media screen and (min-width: 1200px) {
        .container-fluid-height {
            min-height: 65vh;
            height: 65vh;
            overflow-y: scroll;
            overflow-x:hidden;
        }
    }
</style>
